@layer legacy {
    .container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        font-family: var(--sans-serif);
    }

    .container input {
        font-family: var(--sans-serif);
    }

    .label:not(:global(.tsqd-parent-container) *) {
        font-size: 1.6rem;
        font-weight: 400;
        line-height: 1.25;
        color: var(--ink);
        margin-bottom: 0.8rem;
    }

    .inputIcon,
    .inputCurrency,
    .input {
        height: 42px;
        border-radius: var(--border-radius);
        border: solid 1px var(--ink-lighter);
        background-color: var(--white);
        padding: 0 16px;
        font-size: 1.6rem;
    }

    .input:focus-visible {
        outline: none;
    }

    .inputIcon:hover,
    .inputCurrency:hover,
    .input:hover {
        border-color: var(--ink-light);
    }

    .inputIcon.focus:not(.error),
    .inputCurrency.focus:not(.error),
    .input:focus {
        box-shadow: 0 0 5px 0 rgba(18, 184, 134, 0.5);
        border: solid 1px var(--lime);
    }

    .inputIcon > input::placeholder,
    .inputCurrency > input::placeholder,
    .input::placeholder {
        color: var(--ink-lighter);
    }

    .inputIcon.disabled,
    .inputCurrency.disabled,
    input:disabled {
        border-color: var(--ink-lighter);
        background-color: var(--paper-dark);
    }

    .inputIcon.error,
    .inputCurrency.error,
    .error {
        border-color: var(--red);
    }

    .errorText {
        color: var(--red);
    }

    .inputIcon > input,
    .inputCurrency > input {
        flex: 1;
        font-size: 1.6rem;
        border: 0;
        border-radius: 0;
        outline: 0;
        padding: 0;
    }

    .inputIcon > input + *,
    .inputCurrency > input + p {
        margin-left: 8px;
        font-family: var(--sans-serif);
    }

    /* Input Currency */

    .inputCurrency {
        display: flex;
    }

    .inputCurrency > input::-webkit-outer-spin-button,
    .inputCurrency > input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    .inputCurrency[type='number'] {
        -moz-appearance: textfield;
    }

    .inputCurrency > input + p {
        line-height: 38px;
        font-family: var(--sans-serif);
    }

    /* Input Icon */

    .inputIcon,
    .inputIcon > input + .iconContainer {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .inputIcon > input + .iconContainer {
        width: 24px;
        height: 24px;
    }

    .inputIcon > .iconContainer > * {
        width: 100%;
    }
}
